import { OPEN_SNACKBAR, CLOSE_SNACKBAR, CREATE_NOTIFICATION, RESUME_SNACKBAR } from './constants';

export const closeSnackbar = () => ({ type: CLOSE_SNACKBAR });

export const resumeSnackbar = () => ({ type: RESUME_SNACKBAR });

export const openSnackbar = () => ({ type: OPEN_SNACKBAR });

export const createNotification = (message, autoHideDuration = 5000) => ({
	type: CREATE_NOTIFICATION,
	message,
	autoHideDuration,
});
